import OldWiresComponentCustom from './WiresComponentCustom'

export default OldWiresComponentCustom